import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = { key: 0 }

import { onMounted, ref } from 'vue';
    import OnboardingGroupeComponent from './components/OnboardingGroupeComponent.vue';
    import router from '@/router';
    import { useRoute } from 'vue-router';
    import ConfirmationModal from '@/components/ConfirmationModal.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingGroupeView',
  setup(__props) {

    const route = useRoute();
    const collectivite = ref(null as any);
    const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);

    onMounted(() => {
        const form_datas = route.meta.form_datas as { collectivite: any };
        collectivite.value = form_datas.collectivite;
    });

    async function onOnboardingCompleted(onboardingResponse: { has_prelevements: boolean, collectivite_id: number }) {
        let confirmation = false;
        if (onboardingResponse.has_prelevements == false) {
            confirmation = await confirmationModalRef.value!.open("Onboarding", `Les membres de la collectivité ${collectivite.value?.nom} ont été importés avec succès. Voulez-vous procéder au premier prélèvement ?`);
        }

        if (confirmation) {
            router.push('/app/finance/prelevements/' + onboardingResponse.collectivite_id);
        } else {
            router.push('/app/users/list?sort=created_at_desc');
        }
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "page-space-30" }, null, -1)),
    (collectivite.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(OnboardingGroupeComponent, {
            collectivite: collectivite.value,
            onCompleted: onOnboardingCompleted
          }, null, 8, ["collectivite"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(ConfirmationModal, {
      ref_key: "confirmationModalRef",
      ref: confirmationModalRef
    }, null, 512)
  ]))
}
}

})